import React, { useEffect, useState } from "react";
import { useDebounce } from "../../modules/core/hooks";
import { useSearch, useSearchFilter } from "../../modules/search/hooks";
import { Spinner } from "react-bootstrap";
import { Searchbar } from "../../modules/core/components";
import { SearchFilter, SearchResult } from "../../modules/search/components";
import "./Search.styles.css";

export const Search = () => {
  const [searchTerm, setSearchTerm] = useState<string>();
  const debouncedSearchTerm = useDebounce(searchTerm, 1000);

  const [sport, setSport] = useState<string>();
  const [venue, setVenue] = useState<string>();
  const [category, setCategory] = useState<string>();
  const [toDate, setToDate] = useState<string>();
  const [fromDate, setFromDate] = useState<string>();

  const onVenueSelect = (venueSelect: any) => {
    setVenue(venueSelect?.target?.value);
  };

  useEffect(() => {
    document.title = `Search | Staidium`;
  }, []);

  const onCategorySelect = (categorySelect: any) => {
    if (category == categorySelect) {
      setCategory(undefined);
      return;
    }

    setCategory(categorySelect);
  };

  const onToDateSelect = (date: any) => {
    setToDate(date?.target?.value);
  };

  const onFromDateSelect = (date: any) => {
    setFromDate(date?.target?.value);
  };

  const { data, isLoading, isError } = useSearch({
    query: debouncedSearchTerm
  });

  const filteredData = useSearchFilter({
    data: data?.data,
    filters: {
      sport,
      venue,
      category,
      date: new Date(),
      toDate,
      fromDate
    }
  });

  return (
    <div className="content-wrapper">
      <div>
        <SearchFilter
          sport={sport}
          onSportChange={setSport}
          venue={venue}
          onVenueChange={onVenueSelect}
          category={category}
          onCategoryChange={onCategorySelect}
          fromDate={fromDate}
          onFromDateChange={onFromDateSelect}
          toDate={toDate}
          onToDateChange={onToDateSelect}
        />
      </div>

      <div className="search--wrapper">
        <div className="searchbar--wrapper mt-3">
          <Searchbar
            onChange={({ currentTarget }) => setSearchTerm(currentTarget.value)}
          />
        </div>

        <h3 className="search--title">Search Results:</h3>
        <hr />

        {isLoading && (
          <div className="loader-wrapper">
            <Spinner animation="border" />
          </div>
        )}

        {isError && <div>is broken</div>}

        {filteredData.events?.map((event) => (
          <>
            <SearchResult key={event.uuid} {...event} type={"event"} />
            <hr />
          </>
        ))}

        {filteredData.venues?.map((venue) => (
          <>
            <SearchResult key={venue.uuid} {...venue} type={"partner"} />
            <hr />
          </>
        ))}
      </div>
    </div>
  );
};
